const state = () => ({
  subscribedTopics: []
});

const getters = {
  getSubscribedTopics(state) {
    return state.subscribedTopics;
  },
};

const actions = {
  subscribeToTopic({ commit, state }, topicInfo) {
    const isSubscribed = state.subscribedTopics.some(sub => sub.topic === topicInfo.topic);
    if (!isSubscribed) {
      commit('ADD_SUBSCRIBED_TOPIC', topicInfo);
    }
  },
  unsubscribeFromTopic({ commit, state }, topic) {
    commit('REMOVE_SUBSCRIBED_TOPIC', topic);
  },
};

const mutations = {
  ADD_SUBSCRIBED_TOPIC(state, topicInfo) {
    console.log(topicInfo);
    // const copiedTopicInfo = JSON.parse(JSON.stringify(topicInfo)); 
    let callbackString = topicInfo?.callback?.toString()
    topicInfo = {
      ...topicInfo,
      callback : callbackString
    }
    state.subscribedTopics.push(topicInfo);
  },
  REMOVE_SUBSCRIBED_TOPIC(state, topic) {
    state.subscribedTopics = state.subscribedTopics.filter(sub => sub.topic !== topic);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
